/** Map from a nav item's labelKey to its bootstrap-icons class. */
export const ITEM_ICONS: Record<string, string> = {
  // Generic
  'nav.overview': 'bi-grid-1x2',
  'spray.tabs.overview': 'bi-grid-1x2',

  // Scouting — capture
  'nav.documentImport': 'bi-file-earmark-text',
  'nav.fieldMode': 'bi-broadcast-pin',
  'nav.phenology': 'bi-flower1',
  'nav.manualMode': 'bi-pencil-square',
  // Scouting — analyze
  'nav.dataExplorer': 'bi-search',

  // Spray — operations
  'spray.tabs.sessions':       'bi-calendar2-event',
  'spray.tabs.mySessions':     'bi-person-workspace',
  // Spray — library
  'spray.tabs.programs':       'bi-clipboard-data',
  'spray.tabs.products':       'bi-box-seam',
  'spray.tabs.inventory':      'bi-archive',
  'spray.tabs.stockLevels':    'bi-archive',
  'spray.tabs.stockMovements': 'bi-arrow-left-right',
  // Spray — resources
  'spray.tabs.machines':       'bi-truck',
  'spray.tabs.operators':      'bi-people',
  // Spray — tools
  'spray.tabs.weatherHistory': 'bi-cloud-sun',
  'spray.tabs.import':         'bi-file-earmark-arrow-up',
};

/** Returns a default icon for a label key, falling back to a generic dot. */
export function iconForLabelKey(labelKey: string): string {
  return ITEM_ICONS[labelKey] ?? 'bi-circle-fill';
}
